<ng-content></ng-content>
<p *ngFor="let message of messages$ | async">{{ message }}</p>
